import React, { useEffect, useRef } from 'react';
import { SEARCH_CHARS_MIN_LIMIT } from '../../consts';
import { getDirectParentFromBreadcrumbs } from '../../utils/breadcrumbs';
import { EmptyState } from './components/EmptyState';
import { Header } from './components/Header';
import { Option } from './components/Option';
import { OptionsSkeleton } from './components/OptionsSkeleton';
import * as S from './styled';
export const Options = ({ initialCategory, selectedCategory, searchValue, options, loading, focusState, onSelect, onNavigateUp, onNavigateDown, }) => {
    const directParent = selectedCategory && getDirectParentFromBreadcrumbs(selectedCategory.breadcrumbs);
    const hasChildren = selectedCategory?.children ? selectedCategory.children.length > 0 : false;
    const displayHeader = !searchValue && selectedCategory && (hasChildren || directParent);
    const optionsListRef = useRef(null);
    const optionRefs = useRef([]);
    useEffect(() => {
        if (focusState.index !== null && optionRefs.current[focusState.index]) {
            optionRefs.current[focusState.index]?.scrollIntoView({
                behavior: 'smooth',
                block: 'nearest',
            });
        }
    }, [focusState.index]);
    const renderContent = () => {
        if (loading) {
            return React.createElement(OptionsSkeleton, null);
        }
        if (searchValue && options.length === 0) {
            return React.createElement(EmptyState, { searchValue: searchValue });
        }
        return (React.createElement(React.Fragment, null,
            displayHeader && (React.createElement(S.HeaderContainer, null,
                React.createElement(Header, { selectedCategory: selectedCategory, focused: focusState.type === 'header', onClick: onNavigateUp, "data-header": true }))),
            React.createElement(S.OptionsList, { ref: optionsListRef }, options.map((option, index) => (React.createElement(S.OptionWrapper, { key: option.id, ref: (el) => (optionRefs.current[index] = el) },
                React.createElement(Option, { searchValue: searchValue.length >= SEARCH_CHARS_MIN_LIMIT ? searchValue : '', selected: initialCategory?.id === option.id, isFocused: focusState.type === 'row' && focusState.index === index, option: option, onSelect: onSelect, onNavigateDown: onNavigateDown })))))));
    };
    return React.createElement(S.Container, null, renderContent());
};
